<mat-expansion-panel [expanded]="true" hideToggle style="min-width: 500px;max-width: 500px;">
    <mat-expansion-panel-header class='header'  style="pointer-events: none;">
      <mat-panel-description>
        Correcting  information
      </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-label style="margin-top: 10px" *ngIf="isError">Please enter incorrect Document Name, Filing Date and Description of Incorrect data
    </mat-label>
    <mat-form-field class="" >
      <mat-form-field appearance="fill">
        <mat-label>Note</mat-label>
        <textarea maxlength="500" [(ngModel)]="note" matInput type="text" class="notes-textarea"></textarea>
      </mat-form-field>
    </mat-form-field>
    <div class="row">
        <div fxLayoutAlign="center"><mat-label>Click Ok to Continue</mat-label></div>
        <div fxLayoutAlign="center"><button mat-raised-button style="margin-top: 10px; width: 50px;" color="primary" (click)="onSubmit()">OK</button></div>
    </div>
  </mat-expansion-panel>